/**
 * Allows a number to be rounded to a particular step, rather than simply a precision.
 * E.g. Choosing a step of "0.5" will round 4.72 to 4.5 rather than 5.
 */
export const roundToStep = (value: number, step = 1.0): number => Math.round(value / step) * step;
